import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Autocomplete,
  Box,
  Button,
  Grid,
  IconButton,
  Paper,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  useTheme
} from '@mui/material'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import React, { useEffect, useState } from 'react'
import { getRequest } from '../../../globalhelper/helper'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import moment from 'moment'
import PropTypes from 'prop-types'
import FirstPageIcon from '@mui/icons-material/FirstPage'
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight'
import LastPageIcon from '@mui/icons-material/LastPage'
import DownloadIcon from '@mui/icons-material/Download'
import store from '../../../store'
import { values } from 'lodash'
import { hideLoader, showLoader } from '../../../redux/Common/commonActions'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
function TablePaginationActions (props) {
  const theme = useTheme()
  const { count, page, rowsPerPage, onPageChange } = props
  const [previousCount, setPreviousCount] = useState(count)

  useEffect(() => {
    if (count !== previousCount && page !== 0) {
      onPageChange(null, 0)
    }
    setPreviousCount(count)
  }, [count, page, onPageChange, previousCount])

  const handleFirstPageButtonClick = event => {
    onPageChange(event, 0)
  }

  const handleBackButtonClick = event => {
    onPageChange(event, page - 1)
  }

  const handleNextButtonClick = event => {
    onPageChange(event, page + 1)
  }

  const handleLastPageButtonClick = event => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1))
  }

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label='first page'
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label='previous page'
      >
        {theme.direction === 'rtl' ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label='next page'
      >
        {theme.direction === 'rtl' ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label='last page'
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  )
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired
}
export default function ReconcilationReports () {
  const [formData, setFormData] = useState({
    company: '',
    fromDate: '',
    toDate: '',
    vendorid: '',
    type: ''
  })
  const [companyName, setCompanyName] = useState([])
  const [companyDetails, setCompanyDetails] = useState([])
  const [successMessage, setSuccessMessage] = useState('')
  const [Reports, setReports] = useState([])
  const [FilteredReports, setFilteredReports] = useState([])
  let [campaign, setCampaign] = useState('')
  let [platform, setPlatform] = useState('')
  const [campaigns, setCampaigns] = useState([])
  const [platforms, setPlatforms] = useState([])
  const [loaded, setLoaded] = useState(false)
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [vendorDetails, setVendorDetails] = useState([])
  const Types = [
    { name: "Bill Vs Po's", value: 'BillVsPos' },
    { name: 'Bill Vs Agreement', value: 'BillVsAgreement' },
    { name: 'Bill Vs InternalReports', value: 'BillVsInternalReports' }
  ]

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const handleSubmit = async () => {
    try {
      const id = companyDetails.filter(
        item => item.orgname === formData.company
      )

      const companyid = id.map(item => item.orgid)
      store.dispatch(showLoader())
      setLoaded(false)
      setPage(0)
      const response = await getRequest(
        `api/veranda/getReconciledReports?forprdfrom=${moment(
          formData.fromDate
        ).format('YYYY-MM-DD')}&forprdto=${moment(formData.toDate).format(
          'YYYY-MM-DD'
        )}&OrgID=${companyid}&VendorID=${formData.vendorid}&type=${
          formData.type.value
        }`
      )
      if ((response.type = 'success')) {
        console.log(response)

        let parsedData = JSON.parse(response.res.data)
        console.log(parsedData)
        setReports(parsedData)
        setFilteredReports(parsedData)
        let campaigns = parsedData
          .map(item => item.Campaign)
          .filter((value, index, self) => self.indexOf(value) === index)
        let platforms = parsedData
          .map(item => item.Platform)
          .filter((value, index, self) => self.indexOf(value) === index)
        console.log(platforms)

        setPlatforms(platforms)
        setCampaigns(campaigns)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoaded(true)
      store.dispatch(hideLoader())
    }
  }

  const convertToCSV = data => {
    if (!data || !data.length) return ''

    const headers = Array.from(new Set(data.flatMap(Object.keys)))

    const headerRow = headers.join(',')
    const rows = data.map(row =>
      headers.map(header => JSON.stringify(row[header] ?? '')).join(',')
    )

    return [headerRow, ...rows].join('\n')
  }

  const downloadCSV = () => {
    const csvData = convertToCSV(Reports)

    const now = new Date().toISOString().replace(/[-:.TZ]/g, '')

    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = `Reports_${now}.csv`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  const handleSuccessClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    setSuccessMessage('')
  }

  const loadCompanies = () => {
    getRequest(`api/upload/getCompanyAndVendors`)
      .then(response => {
        console.log(response.res.data)
        const responseData = JSON.parse(response.res.data)
        const orgname = [...new Set(responseData.map(item => item.orgname))]
        setCompanyDetails(
          responseData
            .map(data => ({
              orgname: data.orgname,
              orgid: data.orgid
            }))
            .filter(
              (value, index, self) =>
                index ===
                self.findIndex(
                  obj =>
                    obj.orgid === value.orgid && obj.orgname === value.orgname
                )
            ) || []
        )
        setVendorDetails(
          responseData
            .map(data => ({
              vendorid: data.vendorid,
              vendorname: data.vendorname
            }))
            .filter(
              (value, index, self) =>
                index ===
                self.findIndex(
                  obj =>
                    obj.vendorid == value.vendorid &&
                    obj.vendorname === value.vendorname
                )
            ) || []
        )
        console.log(
          responseData
            .map(data => ({
              vendorid: data.vendorid,
              vendorname: data.vendorname
            }))
            .filter(
              (value, index, self) =>
                index ===
                self.findIndex(
                  obj =>
                    obj.vendorid == value.vendorid &&
                    obj.vendorname === value.vendorname
                )
            ) || []
        )
        setVendorDetails(
          responseData
            .map(data => ({
              vendorid: data.vendorid,
              vendorname: data.vendorname
            }))
            .filter(
              (value, index, self) =>
                index ===
                self.findIndex(
                  obj =>
                    obj.vendorid == value.vendorid &&
                    obj.vendorname === value.vendorname
                )
            )
        )

        setCompanyName(orgname)
        if (orgname.length === 1) {
          setFormData(prev => {
            return { ...prev, company: orgname[0] }
          })
        }
      })
      .catch(err => console.log(err))
  }

  const handleFilter = (name, value) => {
    console.log(name, value)
    if (name === 'platform') {
      setPlatform(value)
    } else if (name === 'campaign') {
      setCampaign(value)
      setPlatform('')
    }

    let filteredReports =
      Reports.filter(item => {
        if (name === 'platform' && value) {
          if (campaign)
            return item.Campaign === campaign && item.Platform === value
          else return item.Platform === value
        } else if (name === 'campaign' && value) {
          setPlatforms(
            Reports.map(item => {
              if (name === 'campaign' && item.Campaign === value) {
                return item.Platform
              }
            }).filter((value, index, self) => self.indexOf(value) === index)
          )
          return item.Campaign === value
        } else {
          return true
        }
      }) || []

    if (filteredReports.length > 0) setFilteredReports(filteredReports)
  }

  const handleChange = (name, value) => {
    setFormData(prev => {
      return { ...prev, [name]: value }
    })
  }

  useEffect(() => {
    var currentDate = moment()
    var firstDay = currentDate.startOf('month').format('YYYY-MM-DD')
    var lastDay = currentDate.endOf('month').format('YYYY-MM-DD')
    setFormData(prev => {
      return { ...prev, fromDate: firstDay, toDate: lastDay }
    })
    loadCompanies()
  }, [])
  return (
    <>
      <Box>
        <Accordion defaultExpanded>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls='panel1-content'
            id='panel1-header'
          >
            <Typography variant='h6'>Search</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container gap={2}>
              <Grid item xs={1} sm={2} md={2}>
                <Autocomplete
                  options={companyName || []}
                  value={formData.company || ''}
                  onChange={(e, newValue) => handleChange('company', newValue)}
                  fullWidth
                  renderInput={params => (
                    <TextField
                      {...params}
                      label='Company Name'
                      variant='outlined'
                      size='small'
                    />
                  )}
                />
              </Grid>
              <Grid item xs={1} sm={2} md={2}>
                <Autocomplete
                  options={vendorDetails || []}
                  value={
                    formData.vendorid
                      ? vendorDetails.find(
                          v => v?.vendorid === formData?.vendorid
                        )
                      : null
                  }
                  onChange={(e, newValue) =>
                    handleChange('vendorid', newValue ? newValue.vendorid : '')
                  }
                  fullWidth
                  getOptionLabel={option => option?.vendorname || ''}
                  isOptionEqualToValue={(option, value) =>
                    option.vendorid === value.vendorid
                  }
                  renderInput={params => (
                    <TextField
                      {...params}
                      label='Vendor Name'
                      variant='outlined'
                      size='small'
                    />
                  )}
                />
              </Grid>
              <Grid item xs={1} sm={2} md={2}>
                <Autocomplete
                  size='small'
                  fullWidth
                  value={formData.type || null}
                  options={Types}
                  getOptionLabel={option => option?.name || ''}
                  isOptionEqualToValue={(option, value) =>
                    option.name === value?.value || value
                  }
                  onChange={(event, newValue) => {
                    setLoaded(false)
                    handleChange('type', newValue)
                  }}
                  renderInput={params => (
                    <TextField
                      {...params}
                      label='Type'
                      variant='outlined'
                      name='Type'
                    />
                  )}
                />
              </Grid>
              <Grid item xs={1} sm={2} md={2}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DatePicker
                    label='From'
                    value={formData.fromDate}
                    inputFormat='DD-MM-YYYY'
                    minDate={moment().subtract(1, 'year').startOf('year')}
                    maxDate={moment().endOf('year')}
                    views={['year', 'month', 'day']}
                    onChange={newValue => handleChange('fromDate', newValue)}
                    renderInput={params => (
                      <TextField fullWidth size='small' {...params} />
                    )}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={1} sm={2} md={2}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DatePicker
                    label='To'
                    value={formData.toDate}
                    inputFormat='DD-MM-YYYY'
                    minDate={moment().subtract(1, 'year').startOf('year')}
                    maxDate={moment().endOf('year')}
                    views={['year', 'month', 'day']}
                    onChange={newValue => handleChange('toDate', newValue)}
                    renderInput={params => (
                      <TextField fullWidth size='small' {...params} />
                    )}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item display='flex' gap={2}>
                <Button
                  type='button'
                  variant='contained'
                  color='primary'
                  disabled={Object.values(formData).some(item => item === '')}
                  onClick={() => handleSubmit()}
                >
                  Submit
                </Button>
                <Button
                  variant='outlined'
                  color='error'
                  onClick={() => {
                    setFormData({
                      company: '',
                      vendorid: ''
                    })
                    var currentDate = moment()
                    var firstDay = currentDate
                      .startOf('month')
                      .format('YYYY-MM-DD')
                    var lastDay = currentDate
                      .endOf('month')
                      .format('YYYY-MM-DD')
                    setFormData(prev => {
                      return { ...prev, fromDate: firstDay, toDate: lastDay }
                    })
                  }}
                >
                  Reset
                </Button>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
        {(formData.type === 'BillVsPos' ||
          formData.type === 'FinalSpend' ||
          formData.type === 'FinalRecon') &&
          loaded && (
            <Accordion defaultExpanded>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls='panel1-content'
                id='panel1-header'
              >
                <Typography variant='h6'>Filter</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container gap={2}>
                  <Grid item xs={1} sm={2} md={3}>
                    <Autocomplete
                      size='small'
                      options={campaigns}
                      value={campaign || null}
                      onChange={(event, newValue) =>
                        handleFilter('campaign', newValue)
                      }
                      renderInput={params => (
                        <TextField
                          label='Campaign'
                          variant='outlined'
                          name='campaign'
                          {...params}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={1} sm={2} md={3}>
                    <Autocomplete
                      size='small'
                      value={platform || null}
                      fullWidth
                      options={platforms}
                      getOptionLabel={option => option || ''}
                      isOptionEqualToValue={(option, value) => option === value}
                      onChange={(event, newValue) =>
                        handleFilter('platform', newValue)
                      }
                      renderInput={params => (
                        <TextField
                          {...params}
                          label='Platform'
                          variant='outlined'
                          name='platform'
                        />
                      )}
                    />
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>
          )}
        {(FilteredReports.length > 0 && loaded && (
          <>
            <Box
              sx={{ display: 'flex', justifyContent: 'space-between' }}
              mb={2}
            >
              <Typography variant='h6'>Reports</Typography>
              <Button
                variant='contained'
                color='success'
                size='small'
                disabled={!(Reports.length > 0)}
                onClick={() => downloadCSV()}
                sx={{ whiteSpace: 'nowrap', marginRight: 2 }}
                title='Generate CSV'
              >
                <DownloadIcon />
              </Button>
            </Box>
            <TableContainer
              sx={formData.type === 'BDVsBs' ? { width: '40vw' } : ''}
              component={Paper}
            >
              <Table
                sx={{ minWidth: 650 }}
                size='small'
                aria-label='a dense table'
              >
                <TableHead>
                  <TableRow>
                    {Object.keys(FilteredReports[0]).map((key, index) => (
                      <TableCell key={index}>{key}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(rowsPerPage > 0
                    ? FilteredReports.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                    : FilteredReports
                  ).map((item, rowIndex) => (
                    <>
                      <TableRow key={rowIndex}>
                        {Object.keys(FilteredReports[0]).map((key, index) => (
                          <TableCell key={index}>{item[key]}</TableCell>
                        ))}
                      </TableRow>
                    </>
                  ))}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      rowsPerPageOptions={[
                        5,
                        10,
                        25,
                        { label: 'All', value: -1 }
                      ]}
                      colSpan={FilteredReports.length - 1}
                      count={FilteredReports.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      slotProps={{
                        select: {
                          inputProps: {
                            'aria-label': 'FilteredReports per page'
                          },
                          native: true
                        }
                      }}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      ActionsComponent={TablePaginationActions}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </>
        )) ||
          ''}
      </Box>
    </>
  )
}
